// class CartNotification extends HTMLElement {
//   constructor() {
//     super();

//   }

//   async hydrate(){
//     try {
//       const response = await fetch(window.Shopify.routes.root + 'cart?view=sync');
//       const res = await response.text();
  
//       let p = new DOMParser();
//       let doc = p.parseFromString(res, 'text/html');      
//       let template = doc.querySelector('#cart-notification');

//       console.log(template);

//       let original = document.querySelector('#main-cart-notification');
//       let prev = document.querySelector('#cart-notification');

//       original.replaceChild(template, prev);
//       // _counter.setAttribute('data-in-sync', true);
//     } catch (error) {
//       console.error('Error:', error);
//     }
//   }


// }

// customElements.define("cart-notification", CartNotification);


class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.notificationProductList = document.getElementById(
      "cart-notification-product-list",
    );

    // accessing notification clone elements
    this.notificationCloneProduct = document.getElementById(
      "cart-notification-clone-product-list",
    );
    this.cloneProductPriceSubtotal = document.getElementById(
      "cart-notification-clone-price-subtotal",
    );

    this.cartCurrencySymbol = this.notification.getAttribute("data-currency");
    this.header = document.querySelector("sticky-header");
    this.cartLinks = document.getElementById("cart-notification-links");
    this.totalProductQuantity = 0;
    this.productQuantity = document.getElementById(
      "cart-notification-quantity",
    );
    this.totalProductPrice = 0;
    this.productPrice = document.getElementById("cart-notification-price");
    this.productPriceSubtotal = document.getElementById(
      "cart-notification-price-subtotal",
    );
    this.lineIndex = 0;
    this.cartContentsRequestId = 0;
    // this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );

    this.fetchCartContents(true);
  }

  fetchCartContents(defaultCartOnly = false) {
    const requestId = ++this.cartContentsRequestId;
    const configLoad = fetchConfig("javascript");
    configLoad.headers["X-Requested-With"] = "XMLHttpRequest";
    delete configLoad.headers["Content-Type"];

    fetch(`${routes.cart_url}`, configLoad)
      .then((response) => response.json())
      .then((response) => this.addCompareAtPrice(response))
      .then((response) => {
        // A cart mutation may have started a newer refresh while this request
        // was in flight. Never let the older response restore stale contents.
        if (requestId !== this.cartContentsRequestId) return;
        this.renderContents(
          response.items,
          "no-sections",
          "full-cart",
          defaultCartOnly,
          response.total_price
        );
      })
      .catch((e) => {
        console.error(e);
      });
    return;
  }

  addCompareAtPrice(cart) {
    if (cart.items.length === 0) return Promise.resolve(cart);

    return new Promise((resolve) => {
      let counter = 0;
      cart.items.forEach((item, index, array) => {
        fetch(`/products/${item.handle}/.js`)
          .then((res) => {
            return res.json();
          })
          .then((product) => {
            counter++;
            product.variants.forEach((variant) => {
              if (
                variant.compare_at_price != null &&
                variant.id == item.variant_id
              )
                item["compare_at_price"] = variant.compare_at_price;
              else item["compare_at_price"] = 0;
            });
            if (counter === array.length) {
              resolve(cart);
            }
          });
      });
    });
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true},
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  getPriceWithDecimals(price) {
    let priceString = "" + price;
    priceString =
      priceString.substring(0, priceString.length - 2) +
      "." +
      priceString.substring(priceString.length - 2);
    return Number(priceString);
  }

  getPriceWithCurrency(priceWithDecimals) {
    return "" + this.cartCurrencySymbol + priceWithDecimals;
  }

  createHTML(item, modifier = "", clone = false) {

    let priceWithDecimals;
    if (item.discounts.length < 1) {
      priceWithDecimals = this.getPriceWithDecimals(item.price);
    } else {
      priceWithDecimals = this.getPriceWithDecimals(item.discounted_price);
    }

    const formattedPrice = this.getPriceWithCurrency(priceWithDecimals);
    const quantityPrice = (priceWithDecimals * item.quantity).toFixed(2);
    const formattedQuantityPrice = this.cartCurrencySymbol + (item.final_line_price / 100).toFixed(2);

    let originalPriceWithDecimals,
      originalFormattedPrice,
      originalQuantityPrice,
      originalFormattedQuantityPrice = "";

    if (+item.compare_at_price > 0) {
      originalPriceWithDecimals = this.getPriceWithDecimals(
        item.compare_at_price,
      );
    }

    if (item.discounts.length > 0) {
      originalPriceWithDecimals = this.getPriceWithDecimals(item.price);
    }

    if (+item.compare_at_price > 0 || item.discounts.length > 0) {
      originalFormattedPrice = this.getPriceWithCurrency(
        originalPriceWithDecimals,
      );
      originalQuantityPrice = (
        originalPriceWithDecimals * item.quantity
      ).toFixed(2);

      originalFormattedQuantityPrice =
        this.cartCurrencySymbol +
        (Math.round(+originalQuantityPrice * 100) / 100).toFixed(2);
    }

    if (!clone) {
      this.totalProductQuantity += item.quantity;
      this.totalProductPrice += Number(quantityPrice);
    }

    let html = `
      <div class="cart-notification-product cart-notification-product${modifier}">
        <img src="${item.featured_image.url}" alt="image of ${
      item.title
    }" width="200" height="200">
        <div class="cart-notification-product__details">
          <h6 class="cart-notification-product__details-title"><a href="${
            item.url
          }">${item.product_title}</a></h6>
          <span class="cart-notification-product__details-variant-title 
          ${item.product_has_only_default_variant ? "no-variant" : ""}">${
      item.variant_title
    }</span>
          <span class="cart-notification-product__details-quantity-text">Quantity</span>
          <div class="cart-notification-product__quantity-price-wrapper">
    `;

    if (clone) {
      this.lineIndex += 1;
      html += `
      <quantity-input class="cart-notification-product-clone__quantity quantity">
        <div class="quantity__input-wrapper">
        
          <button class="button quantity__button quantity__button--minus no-js-hidden cart-notification-clone-minus-btn" name="minus" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
          </svg>
        
          </button>
          <input class="quantity__input cart-notification-clone-quantity"
              ${item.discounts.length > 0 ? "offer-item" : ""}
              type="number"
              name="quantity"
              min="1"
              value="${item.quantity}"
              max="10"
              data-product-id="${item.id}"
              data-line-index="${this.lineIndex}"
            >

          <button class="button quantity__button quantity__button--plus no-js-hidden cart-notification-clone-plus-btn" name="plus" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
          </svg>
          </button>

        </div>
      </quantity-input> 
      `;
    } else {
      html += `
        <span class="cart-notification-product__details-quantity-amount">x${item.quantity}</span>
        `;
    }

    html += `
          <div class="cart-notification-product__details-prices">
            <span class="cart-notification-product__details-original-price
            cart-notification-product__details-price${modifier}"
            data-product-price="${originalPriceWithDecimals}"
            data-product-price-currency="${originalFormattedPrice}"
            data-product-price-total=${originalQuantityPrice}
            ><span class="money">${originalFormattedQuantityPrice}</span></span>

            <span class="cart-notification-product__details-price cart-notification-product__details-price${modifier}
            cart-notification-product__details-new-price"
            data-product-price="${priceWithDecimals}"
            data-product-price-currency="${formattedPrice}"
            data-product-price-total=${quantityPrice}
            ><span class="money">${formattedQuantityPrice}</span></span>
          </div>
        </div  
      </div>
    </div> 
    `;

    return html;
  }

  setTotals(subtotal) {
    this.productQuantity.textContent = this.totalProductQuantity;
    const formattedTotal =  this.cartCurrencySymbol + (subtotal / 100).toFixed(2);
  
    // const formattedTotal =  this.cartCurrencySymbol + (Math.round(subtotal * 100) / 100).toFixed(2);


    this.productPrice.firstElementChild.textContent = formattedTotal;
    this.productPriceSubtotal.firstElementChild.textContent = formattedTotal;

    if (this.cloneProductPriceSubtotal) {
      this.cloneProductPriceSubtotal.textContent = formattedTotal;
      this.cloneProductPriceSubtotal.setAttribute(
        "data-subtotal",
        (Math.round(this.totalProductPrice * 100) / 100).toFixed(2),
      );
    }
  }

  renderContents(parsedState, sections, type, defaultCartOnly = false, subtotal) {
    this.lineIndex = 0;
    if (parsedState.length < 1) return;

    this.cartLinks.classList.add("cart-not-empty");

    this.notificationProductList.innerHTML = "";
    if (!defaultCartOnly) {
      this.notificationCloneProduct.innerHTML = "";
    }
    this.totalProductQuantity = 0;
    this.totalProductPrice = 0;

    if (sections === "no-sections") {
      parsedState.forEach((item) => {
        this.cartItemKey = item.key;

        this.notificationProductList.insertAdjacentHTML(
          "afterbegin",
          this.createHTML(item),
        );

        if (!defaultCartOnly) {
          this.notificationCloneProduct.insertAdjacentHTML(
            "beforeend",
            this.createHTML(item, "--clone", true),
          );
        }

        this.setTotals(subtotal);
      });

      const cartBubbleCount =
        document.querySelector(".cart-count-bubble").firstElementChild;
      if (cartBubbleCount)
        cartBubbleCount.textContent = this.totalProductQuantity;

      const cloneCart = document.querySelector("cart-notification-clone");
      if (cloneCart) cloneCart.addQuantityInputEvents();

      return;
    }

    if (type == "full-cart") {
      this.lineIndex = 0;

      parsedState.forEach((item) => {
        this.cartItemKey = item.key;
        this.getSectionsToRender().forEach((section) => {
          if (section.id === "cart-notification-product") {
            this.notificationProductList.insertAdjacentHTML(
              "beforeend",
              this.createHTML(item),
            );
            if (!defaultCartOnly) {
              this.notificationCloneProduct.insertAdjacentHTML(
                "beforeend",
                this.createHTML(item, "--clone", true),
              );
            }

            this.setTotals(subtotal);
          } else {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(sections[section.id], section.selector);
          }
        });
      });
    } else {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector,
          );
      });
    }

    document.querySelector("cart-notification-clone").showClone();
    if (this.header) this.header.reveal();
    // this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-icon-bubble",
      }
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
